import { useEffect, useRef } from 'react';

const useDebounceEffect = (fnc, delay, deps = []) => {
	const ref = useRef();

	useEffect(() => {
		clearTimeout(ref.current);
		ref.current = setTimeout(() => {
			fnc();
			clearTimeout(ref.current);
		}, delay);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [...deps]);
};

export default useDebounceEffect;
